import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { first } from 'rxjs/operators';
import { NotificationInboxService } from '@core/services/notification-inbox.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnInit {
  unreadCount = 0;
  private readonly _destroyRef = inject(DestroyRef);
  private _notificationInboxService = inject(NotificationInboxService);

ngOnInit(): void {
  this._notificationInboxService.getNotifications()
    .pipe(first(), takeUntilDestroyed(this._destroyRef))
    .subscribe({
      next: page => {
        this.unreadCount = page.content.filter(n => !n.read).length;
      },
      error: () => {
        // silently ignore — a failed notification fetch shouldn't affect the session
      }
    });
    
     this._notificationInboxService.unreadCount$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(count => {
        this.unreadCount = count;
      });
}
}
